import classNames from 'classnames';
import * as styles from './label.linaria';
function Label({ labelClassName, value, inputId, hideLabel }) {
    return (<label id={inputId && `label_${inputId}`} htmlFor={inputId} className={classNames([
            styles.Label,
            hideLabel && 'visually-hidden',
            labelClassName,
        ])}>
      {value}
    </label>);
}
Label.defaultProps = {
    labelClassName: null,
    hideLabel: false,
    inputId: null,
};
export default Label;
